// src/pages/InviteRedirect.jsx
import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { getInvitationInfo } from "../services/invitationService";
import { useSelector } from "react-redux";

/*
  Short English comments only:
  This component loads invitation info, checks if userExists,
  then redirects to /login?inviteToken=... or /register?inviteToken=...
  Optionally also pass inviteEmail=... if needed
*/

export default function InviteRedirect() {
  const { token } = useParams();
  const navigate = useNavigate();
  const { user } = useSelector((state) => state.user);

  useEffect(() => {
    // if user is already logged in and the email matches => we can accept automatically
    // or we can just do getInvitationInfo anyway.
    async function checkInvite() {
      try {
        const info = await getInvitationInfo(token);
        const inviteEmail = encodeURIComponent(info.email);
        const inviteToken = encodeURIComponent(token);

        // if userExists => redirect to login with query
        // if not => redirect to register
        if (info.userExists) {
          navigate(`/login?inviteToken=${inviteToken}&inviteEmail=${inviteEmail}`);
        } else {
          navigate(`/register?inviteToken=${inviteToken}&inviteEmail=${inviteEmail}`);
        }
      } catch (err) {
        console.error("InviteRedirect error:", err);
        // fallback if invitation invalid
        navigate("/rooms");
      }
    }

    checkInvite();
  }, [token, navigate, user]);

  return null; // shows nothing, just auto-redirect
}
